import { ShippingApiClient } from '@fourthwall/services/dist/ShippingApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShopShippingFlatRatesQuery = createQueryHook(ShippingApiClient.getFlatRates, {
  queryKey: ['shopShippingFlatRates'],
})
